export default __webpack_public_path__ + "static/sqlite-c9240b1d0532936689d28abf3cd89f57.png";